const ONES = [
  'cero', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve',
  'diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete', 'dieciocho', 'diecinueve',
  'veinte', 'veintiuno', 'veintidós', 'veintitrés', 'veinticuatro', 'veinticinco', 'veintiséis', 'veintisiete', 'veintiocho', 'veintinueve',
];
const TENS = ['', '', '', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'];
const HUNDREDS = ['', 'ciento', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos', 'seiscientos', 'setecientos', 'ochocientos', 'novecientos'];

/**
 * Número en letras, en español (0-999). Para valores fuera de rango devuelve
 * el dígito tal cual — no se espera usar esto con conteos de sesiones de ese
 * orden. Port 1:1 de la misma utilidad en psima (`spanish-numbers.ts`), para
 * que la Constancia de Atención use exactamente la misma redacción.
 */
export function spellOutNumber(n: number): string {
  if (!Number.isInteger(n) || n < 0 || n > 999) return String(n);
  if (n < 30) return ONES[n];
  if (n < 100) {
    const tens = Math.floor(n / 10);
    const units = n % 10;
    return units === 0 ? TENS[tens] : `${TENS[tens]} y ${ONES[units]}`;
  }
  if (n === 100) return 'cien';
  const hundreds = Math.floor(n / 100);
  const rest = n % 100;
  return rest === 0 ? HUNDREDS[hundreds] : `${HUNDREDS[hundreds]} ${spellOutNumber(rest)}`;
}

/**
 * Igual que spellOutNumber pero en femenino ("una", "veintiuna", "treinta y
 * una"...), para concordar con sustantivos como "sesión".
 */
export function spellOutNumberFeminine(n: number): string {
  return spellOutNumber(n).replace(/uno$/, 'una');
}
